import { Component } from '@angular/core'

@Component({
  selector: 'cover-debit-charge-cancel-dialog',
  templateUrl: './debit-charge-cancel-dialog.component.html',
  styleUrls: ['./debit-charge-cancel-dialog.component.scss'],
})
export class DebitChargeCancelDialogComponent {
  constructor() {}
}
